import { h, Component } from 'preact';
import { connect } from 'react-redux';

import * as actions from '../actions';
import reduce from '../reducers';

import constants from '../constants';
import store from "../store";
import util from "../util";
import Spinner from './Spinner';
import designDomain from '../domain/designDomain';
import FavoriteButton from './FavoriteButton';
import StockPhotoCard from './card/StockPhotoCard';
import designService from '../service/designService';
import imageService, { getFreeImageThumbPath, getImageType, getS3Path } from '../service/imageService';

import axios from 'axios';

import Masonry from 'react-masonry-component';
import ConfigureFreeImageModal from './ConfigureFreeImageModal';

let allowLoad = true;

export default @connect(reduce, actions)
class AsideFreeImages extends Component {
    constructor() {
        super()
        this.state = {
            images: [],
            freeImages: [],
            categories: constants.freeCategories,
            content: '',
            recentsContent: '',

            isLoadingMore: false,
            isReloading: false,
            isLoadingRecents: false,
            isSearching: false,
            isDefaultView: false,
            curPage: 1,
            curTerm: 'restaurant',
            selectedCategory: null,

            freeImageToConfigure: '',
        }

        this.showConfigureFreeImageModal = (image, event) => {
            if (!this.props.isDesigner) return;

            event.stopPropagation();
            designService.getFreeImage(image.id).then(response => {
                const image = new designDomain.FreeImage(response.data);

                this.setState({ freeImageToConfigure: image });
                this.props.showConfigureFreeImageModal();
            })
        };

        this.onConfigureFreeImageModalClose = () => {
            this.props.hideConfigureFreeImageModal();
        };

        this.onSearchEnter = (ev) => {
            this.setState({ selectedCategory: null });

            if (!this.state.isSearching) {
                //this.trackSearch();
            }

            this.setState({
                isSearching: true,
                isReloading: true,
                isDefaultView: false
            });

            util.nextTick(() => {
                let searchTerm = encodeURIComponent(ev.target.value);
                let images = [];
                imageService.searchPixabayImages(searchTerm, "1").then(resp => {
                    let data = resp.data.hits;
                    images = data.map((image => {
                        return this.getImageComponent(image);
                    }))

                    let toContent = images.length === 0 ? <p style="margin-left: 1rem;">No matches found.</p>
                        : <div>
                            <Masonry updateOnEachImageLoad={true} className={'masonry-grid'}>
                                {images}
                            </Masonry>
                        </div>
                    this.setState({ isReloading: false, isSearching: false, images: images, content: toContent, curPage: 1, curTerm: searchTerm });
                })
            });
        }

        this.clearSearch = () => {
            $('#delete-icon').hide();
            $('#photoSearch').val('');
            this.setState({ isReloading: true });
            util.nextTick(() => {
                this.showDefaultImages();
            })
        }

        this.getOldIimageComponent = (imageUrl, imagePreview) => {
            return (<div class="component template" data-component="image">
                <div class="image" data-component="image" data-path-original={imageUrl}>
                    <picture>
                        <source srcSet={imagePreview} type="image/jpg" />
                        <img loading={'lazy'} style="width: 100%; height: 100%;" className="img" src={imagePreview} />
                    </picture>
                </div>
            </div>)
        }

        this.getImageComponent = (image) => {
            return <StockPhotoCard image={image} isFavorite={image.isFavorite} />

            // let pixabayId = image.id || image.pixabayId;
            // let hoverDiv = (<div class="author-info"><a href={image.pageURL} target="_blank">{image.user} | Pixabay</a></div>)
            // return (
            // <div class="component template frame" data-component="frame">
            //     <div data-type="frame" class="frame" data-component="frame" data-path-original={image.largeImageURL}
            //         data-pixabay-info={`{"id":${pixabayId}, "user":"${image.user}", "pageURL":"${image.pageURL}", "previewURL":"${image.previewURL}", "tags":"${image.tags ? image.tags : ''}"}`}>
            //         <div className="img" data-original-bg-img={image.largeImageURL} style={`width: 100%; height: 100%;`}>
            //             <picture>
            //                 <source srcSet={image.previewURL} type="image/jpg" />
            //                 <img style="width: 100%; height: 100%;" className="img" src={image.previewURL} alt={image.tags ? image.tags : ''} />
            //             </picture>
            //             <FavoriteButton assetId={image.id} type="stock-photo" />
            //         </div>
            //         {hoverDiv}
            //     </div>
            // </div>
            // )
        }

        // this.getVideoComponent = (image) => {
        //     let pixabayId = image.id || image.pixabayId;
        //     let hoverDiv = (<div class="author-info"><a href={image.pageURL} target="_blank">{image.user} | Pixabay</a></div>)
        //     let videoUrl = image.videos.large ? image.videos.large.url : image.videos.medium.url;
        //     return (<div class="component template frame" data-component="frame">
        //                 <div data-type="frame" class="frame" data-component="frame" data-path-original={videoUrl} 
        //                     data-pixabay-info={`{"id":${pixabayId}, "user":"${image.user}", "pageURL":"${image.pageURL}", "previewURL":"${videoUrl}"}`}>
        //                     <div className="video" style={`width: 100%; height: 100%;`} data-original-bg-video={videoUrl}
        //                         dangerouslySetInnerHTML={{
        //                             __html:
        //                                 `<video 
        //                                 autoplay loop muted disablepictureinpicture playsinline
        //                                 src=${image.videos.tiny.url} 
        //                                 style="width: 100%; height: 100%; object-fit: cover;" />`
        //                             }} />
        //                     {hoverDiv}
        //                 </div>
        //             </div>)
        // }

        // this.getMediaComponent = (media) => {
        //     if (media.type === "film" || media.type === "animation") {
        //         return this.getVideoComponent(media);
        //     } else {
        //         return this.getImageComponent(media);
        //     }
        // }

        this.showDefaultImages = () => {
            let images = [];
            imageService.searchPixabayImages('restaurant', "1").then(resp => {
                let data = resp.data.hits;
                images = data.map((image => {
                    return this.getImageComponent(image);
                }))

                let toContent = images.length === 0 ? <p style="margin-left: 1rem;">No matches found.</p>
                    : <div>
                        <div class="label">
                            <h6>All results</h6>
                        </div>
                        <Masonry updateOnEachImageLoad={true} className={'masonry-grid'}>
                            {images}
                        </Masonry>
                    </div>
                this.setState({ isLoadingMore: false, isReloading: false, images: images, content: toContent, curPage: 1, curTerm: 'restaurant', selectedCategory: null, isDefaultView: true });
            });
            this.loadRecents();
        }

        this.loadRecents = () => {
            let images = [];
            this.setState({ isLoadingRecents: true });
            imageService.getMemberRecentImages(this.props.memberId).then(resprecent => {
                let recents = resprecent.data;
                if (recents.length === 0) {
                    this.setState({ isLoadingRecents: false, recentsContent: '' });
                } else {
                    recents = recents.reverse();
                    images = recents.map((recent => {
                        if (recent.largeImageURL && recent.previewURL && recent.pageURL.indexOf('videos') == -1) {
                            return this.getImageComponent(recent);
                        }
                    }))
                    let toContent = <div>
                        <div class="label">
                            <h4 style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
                                <span>Recently used</span>
                                <a onClick={() => this.showAllRecents()} style="display: inline;"> See all &gt;</a>
                            </h4>
                        </div>
                        <Masonry updateOnEachImageLoad={true} className={'masonry-grid'}>
                            {images.slice(0, 2)}
                        </Masonry>
                    </div>;
                    this.setState({ isLoadingRecents: false, recentsContent: toContent });
                }
            })
        }

        this.showAllRecents = () => {
            this.setState({ isReloading: true, isDefaultView: false });
            util.nextTick(() => {
                imageService.getMemberRecentImages(this.props.memberId).then(resprecent => {
                    let recents = resprecent.data;
                    recents = recents.reverse();
                    let images = recents.map((recent => {
                        if (recent.largeImageURL && recent.previewURL) {
                            return this.getImageComponent(recent);
                        }
                    }))
                    images = recents.map((recent => {
                        if (recent.largeImageURL && recent.previewURL && recent.pageURL.indexOf('videos') == -1) {
                            return this.getImageComponent(recent);
                        }
                    }))
                    let toContent =
                        <div>
                            <div class="label">
                                <span>
                                    <a onClick={() => this.showDefaultImages()} style="margin-left: 0;">All results</a>
                                    &nbsp;&nbsp;&gt;&nbsp;&nbsp;<b>Recently used</b>
                                </span>
                            </div>
                            <Masonry updateOnEachImageLoad={true} className={'masonry-grid'}>
                                {images}
                            </Masonry>
                        </div>
                    this.setState({ isReloading: false, content: toContent, curTerm: null });
                })
            })
        }

        this.clearRecents = () => {
            const this2 = this;
            imageService.clearRecentImages(this.props.memberId).then(function () {
                console.log("Cleared");
                this2.showDefaultImages();
            });
        }
    }

    componentDidMount() {
        $('.folders').on('scroll', () => {
            util.checkScroll($('.folders'));
        });
        $('.scroll-left').hide();
        $('#delete-icon').hide();

        util.nextTick(() => {
            this.showDefaultImages();
            this.addLoadListener();
        })
    }

    componentWillMount() {
        this.setState({ isReloading: true });
        imageService.getFreeImages().then(response => {
            let images = [];
            response.data.forEach(function (it) {
                let image = new designDomain.FreeImage(it);
                images.push(image);
            })
            this.setState({ freeImages: images });
        });
    }

    addLoadListener() {
        const scrollerDiv = $('#app-aside-free-images>.scroller');
        const componentsDiv = $('#app-aside-free-images>.scroller>.components');
        scrollerDiv.on('scroll', () => {
            if (allowLoad && scrollerDiv.scrollTop() >= Math.floor(componentsDiv.height() - scrollerDiv.height())) {
                this.loadMore();
                allowLoad = false;
                setTimeout(() => {
                    allowLoad = true;
                }, 1000);
            }
        })
    }

    loadMore() {
        if (!this.state.isReloading) {
            this.setState({ isLoadingMore: true });
            if (this.state.curTerm !== null) {
                imageService.searchPixabayImages(this.state.curTerm, `${this.state.curPage + 1}`).then(resp => {
                    let data = resp.data.hits;
                    let newImages = data.map((image => {
                        return this.getImageComponent(image);
                    }))

                    let images = this.state.images.concat(newImages);

                    let toContent = <div>
                        {this.state.isDefaultView && <div class="label">
                            <h6>All results</h6>
                        </div>}
                        <Masonry updateOnEachImageLoad={true} className={'masonry-grid'}>
                            {images}
                        </Masonry>
                    </div>
                    this.setState({ isLoadingMore: false, images: images, content: toContent, curPage: this.state.curPage + 1 });
                })
            }
        }
    }

    showCategory(category) {
        this.setState({ isReloading: true, isDefaultView: false });
        util.nextTick(() => {
            if (category) {
                let inCat = this.state.freeImages.filter(function (image) {
                    if (image.categoryIdList.length > 0) {
                        return image.categoryIdList.includes(category.id);
                    } else {
                        return image.categoryId === category.id;
                    }
                })
                let images = inCat.map((image => {
                    return this.getOldIimageComponent(constants.SECURE_S3_PATH + image.s3Path, getFreeImageThumbPath(image.s3Path));
                }))
                let toContent = <Masonry updateOnEachImageLoad={true} className={'masonry-grid'}>
                    {images}
                </Masonry>
                this.setState({
                    selectedCategory: category,
                    content: toContent
                });
            } else {
                this.showDefaultImages();
            }
            util.nextTick(() => {
                this.setState({ isReloading: false });
            })
        })
    }

    goBack() {
        this.props.goToRoot();
    }

    onChange(event) {
        this.forceUpdate();
        const file = event.target.files[0];
        const formData = new FormData();
        formData.append('file', file);

        /*this.setState({isUploadLoading: true});
        imageService.uploadFreeImage(formData).then(response => {
          this.setState({
            isUploadLoading: false,
            isConfirmModalOpen: true
          });
          this.forceUpdate();
          $('body').click()
        }, () => {
          this.setState({isUploadLoading: false});
          this.forceUpdate();
        })*/
    }

    render(props, state) {
        /*let uploadBox = null;
        if (state.isUploadLoading) {
            uploadBox = <Spinner/>;
        } else {
            uploadBox = <div>
                <input type="file" name="image" onChange={this.onChange.bind(this)} accept="image/*" className="input-file"/>
                <div>
                <a className="btn primary medium">
                    <span>Upload Images</span>
                </a>
                <p>... or just drag them from your desktop</p>
                </div>
            </div>
        }*/

        const imageLoadingSpinner = state.isLoadingMore ? <Spinner /> : null

        let categories = null;
        let namedCats = state.categories.map(category => {
            return (<a class={"btn medium" + (state.selectedCategory && state.selectedCategory.id === category.id ? ' primary' : ' secondary1')} onClick={() => this.showCategory(category)}>
                {category.label}
            </a>)
        })

        categories = (
            <div class="folders-container">
                <div class="scroll-left" onClick={(ev) => util.scrollLeft(ev)}>
                    <svg>
                        <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-back-icon"} />
                    </svg>
                </div>
                <div class="scroll-right" onClick={(ev) => util.scrollRight(ev)}>
                    <svg>
                        <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-back-icon"} />
                    </svg>
                </div>
                <div class="folders">
                    <a class={"btn medium pixabay" + (!state.selectedCategory ? ' primary' : ' secondary1')} onClick={() => this.showCategory(null)}>
                        <svg><use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-icon-pixabay"} /></svg>
                    </a>
                    {namedCats}
                </div>
            </div>)

        return (
            <div id="app-aside-free-images" class={"aside-text" + (props.isDesigner ? " is-designer" : "") + (state.selectedCategory ? " is-category" : "")}>
                <div class="to-root">
                    <a onClick={() => this.goBack()}>
                        All graphics
                    </a>
                    <span class="path">&gt;&nbsp; Stock Photos</span>
                </div>
                {/*<div className={'dropbox ' + ((props.isDesigner && !props.isPhotoSwap) ? '' : 'hidden')}>
                    {uploadBox} 
                </div>*/}
                <header>
                    <div className="input-search-templates">
                        <input type="text" id="photoSearch" className="search-templates" placeholder="Search royalty-free stock photos"
                            onKeyUp={(ev) => {
                                if (ev.key === 'Enter') {
                                    var onChangeField = this.onSearchEnter.bind(ev);
                                    onChangeField(ev);
                                }
                            }}
                            onChange={(ev) => ev.target.value !== '' ? $('#delete-icon').show() : $('#delete-icon').hide()} />
                        <svg id="delete-icon" onClick={() => this.clearSearch()} className="icon icon-delete-close"><use xlinkHref="#app-icon-delete-close" /></svg>
                    </div>
                </header>
                {props.isDesigner && categories}

                <div class="scroller">
                    <div class="components images">
                        {state.isDefaultView && <div>
                            {state.isLoadingRecents && !state.isReloading && <Spinner />}
                            {!state.isLoadingRecents && state.recentsContent}
                        </div>}
                        {state.isReloading && <Spinner />}
                        {!state.isReloading && state.content}
                    </div>
                    {/*imageLoadingSpinner*/}
                </div>

                <div class="pixabay-credit">
                    <div>Photos courtesy of</div>
                    <a href="https://pixabay.com/" target="_blank">
                        <svg><use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-icon-pixabay"} /></svg>
                    </a>
                    {(props.isAdmin || props.isDesigner) && <div class="clear-recents" onClick={() => this.clearRecents()}>Clear Recents</div>}
                </div>

                <ConfigureFreeImageModal
                    open={props.isConfigureFreeImageModal}
                    freeImageToConfigure={state.freeImageToConfigure}
                    onModalClose={this.onConfigureFreeImageModalClose} />
            </div>
        )
    }
}

